<div [ngClass]="{'hidden-panel': hiddenPanel}">
    <div>
        @switch (m_addBlockType) {
            @case ('BLOCK_COMPONENTS') {
                <div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px;">
                        <button mat-icon-button (click)="toggleContentView()">
                            @if (contentView == 'app_view') {
                                <mat-icon>view_quilt</mat-icon>
                            } @else {
                                <mat-icon>view_stream</mat-icon>
                            }
                        </button>
                        <app-video-link videoLink="componentsToolbox"></app-video-link>
                    </div>

                    @if (!hideCategoryDropdown) {
                        <div fxLayout="row" fxLayoutAlign="space-between center">

                            <mat-form-field class="filter">
                                <mat-label>{{ 'general.categories' | transloco }}</mat-label>
                                <mat-select [formControl]="categorySelected" panelClass="library-categories-dropdown mat-warn" (selectionChange)="updateCategorySelection()" multiple>
                                    @for (item of categorySelections; track item) {
                                        <mat-option [value]="item.id">
                                            {{ item.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <button mat-icon-button class="mini-button" (click)="toggleAllCategories()" [matTooltip]="allCategoriesSelected ? ('ai.deselectAll' | transloco) : ('ai.selectAll' | transloco)">
                                @if (allCategoriesSelected) {
                                    <mat-icon>visibility</mat-icon>
                                } @else {
                                    <mat-icon>visibility_off</mat-icon>
                                }
                            </button>
                        </div>
                    }

                    <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px;">
                        <mat-form-field class="filter">
                            <mat-label>{{ 'general.filter' | transloco }}</mat-label>
                            <input matInput inputrestriction="basic1" autocomplete="off" #filterComponents>
                            <a matSuffix aria-label="Clear" (click)="filterComponents.value = ''">
                                <mat-icon>close</mat-icon>
                            </a>
                        </mat-form-field>
                        <button mat-icon-button class="mini-button" (click)="sortCategories()" matTooltip="{{'general.sort' | transloco}}">
                            <mat-icon>sort_by_alpha</mat-icon>
                        </button>
                        <div class="hide-gt-sm">
                            <app-scroll-buttons contentId="items"></app-scroll-buttons>
                        </div>
                    </div>
                    <div class="items-wrapper">
                        <div class="addBlockWrapper" id="items">
                            @if (!hideCategoryDropdown) {
                                <div cdkDropList cdkDropListSortingDisabled [cdkDropListData]="[mimeTypeBlock]" (cdkDropListDropped)="dropBlock($event)">
                                    <div cdkDrag [cdkDragData]="mimeTypeBlock">
                                        <button class="addMimeStyle" color="warn" mat-flat-button (click)="addBlock(mimeTypeBlock)">
                                            @if (isMimeBased) {
                                                <div class="d-flex-center">
                                                    <mat-icon style="cursor: pointer">add_circle_outline</mat-icon>
                                                    <span>{{ 'general.add' | transloco }} {{ mimeName }}</span>
                                                    <fa-icon size="2x" [icon]="sceneMime | PipeIcon"></fa-icon>
                                                </div>
                                            }
                                            @if (!isMimeBased) {
                                                <div class="d-flex-center">
                                                    <mat-icon style="cursor: pointer">add_circle_outline</mat-icon>
                                                    <span style="padding-right: 5px">{{ 'general.addNewPlaylist' | transloco }}</span>
                                                    <mat-icon>playlist_play</mat-icon>
                                                </div>
                                            }
                                        </button>
                                        <div *cdkDragPreview class="drag-preview" [ngStyle]="{'width.px': 100, 'height.px': 100}">
                                            @if (isMimeBased) {
                                                <fa-icon size="2x" [icon]="sceneMime | PipeIcon"></fa-icon>
                                            }
                                            @if (!isMimeBased) {
                                                <mat-icon>playlist_play</mat-icon>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            @for (cate of categorySelections; track cate) {
                                @if (cate.selected && cate.blocks.length > 0) {
                                    @if ((cate.blocks | FilterForPipe:'name':filterComponents.value).length > 0) {
                                        @if (enterpriseMode) {
                                            <h3 style="margin: 10px; font-weight: bold; padding-top: 15px">{{ cate.name }}</h3>
                                        }
                                        @if (!enterpriseMode) {
                                            <h3 style="margin: 10px; font-weight: bold; padding-top: 15px">{{cate.name}}</h3>
                                        }
                                        <mat-divider></mat-divider>
                                    }
                                    <div class="dragCursor" (cdkDropListDropped)="dropBlock($event)"
                                         [cdkDropListData]="cate.blocks" cdkDropList cdkDropListSortingDisabled
                                         [ngClass]="{'list-view': contentView === 'component_view', 'app-view': contentView !== 'component_view'}">
                                        @for (block of cate.blocks | FilterForPipe:'name':filterComponents.value; track block; let idx = $index) {
                                            <div class="dragCursor"
                                                 cdkDrag [cdkDragData]="block">
                                                @if (contentView === 'component_view') {
                                                    <div fxFlex fxLayoutAlign="space-between center" class="item">
                                                        <div [ngStyle]="Lib.IsBlockAddable(block, user) ? {'opacity': 1} : {'opacity': 0.2}" class="d-flex-center">
                                                            <a class="mini-button" mat-icon-button (click)="addBlock(block)">
                                                                <mat-icon>add_circle_outline</mat-icon>
                                                            </a>
                                                            <span>{{ block.name }}</span>
                                                        </div>
                                                        <div class="d-flex-center">
                                                            <!--
                                                            2-18-2023 removed colorized first item
                                                            <app-video-link *ngIf="block.videoHelp" [ngStyle]="{color: idx === 0 && filterComponents.value === '' ? 'var(--background-blue)' : 'var(--background-color15)'}" [iconButton]="true" [videoLink]="'/help/'+block.name"></app-video-link>
                                                            <fa-icon size="lg" [ngStyle]="{color: idx === 0 && filterComponents.value === '' ? 'var(--background-blue)' : 'var(--background-color15)'}" [icon]="block.icon"></fa-icon>
                                                            -->
                                                            @if (block.videoHelp) {
                                                                <app-video-link [miniButton]="true" [videoLink]="'/help/'+block.name"></app-video-link>
                                                            }
                                                            <fa-icon size="lg" [icon]="block.icon" style="margin-left: 10px;"></fa-icon>
                                                        </div>
                                                    </div>
                                                } @else {
                                                    <div class="app-item">
                                                        <img [ngStyle]="Lib.IsBlockAddable(block, user) ? {'opacity': 1} : {'opacity': 0.2}" class="app-item-image" width="70" height="70" [ngSrc]="'./assets/images/apps/app_' + block.name + '.png'" alt="" onerror="this.onerror=null; this.src='./assets/images/apps/app_Playlist.png'"/>
                                                        <span>{{ block.name }}</span>
                                                        <a class="add-icon" (click)="addBlock(block)">
                                                            <mat-icon>add_circle_outline</mat-icon>
                                                        </a>
<!--                                                        <app-video-link [miniButton]="true" class="add-icon" style="top: 55px; width: 24px; height: 24px;" [videoLink]="'/help/'+block.name"></app-video-link>-->
                                                    </div>
                                                }
                                                <div *cdkDragPreview class="drag-preview" [ngStyle]="{'width.px': 100, 'height.px': 100}">
                                                    @if (contentView !== 'component_view') {
                                                        <img class="app-item-image" width="70" height="70" [ngSrc]="'./assets/images/apps/app_' + block.name + '.png'" alt="" onerror="this.onerror=null; this.src='./assets/images/apps/app_Playlist.png'"/>
                                                    }
                                                    @if (contentView === 'component_view') {
                                                        <span>{{ block.name }}</span>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            }
                            <mat-divider></mat-divider>
                        </div>
                    </div>
                </div>
            }
            @case ('BLOCK_COMPONENTS_VERBOSE') {
                <div>
                    <div fxFlex fxLayoutAlign="start center" class="flex-lt-sm-col">
                        <mat-form-field style="margin-left: 10px; margin-right: 10px; width: 50%;">
                            <mat-label>{{ 'general.categories' | transloco }}</mat-label>
                            <mat-select [formControl]="categorySelected" panelClass="library-categories-dropdown mat-warn" (selectionChange)="updateCategorySelection()" multiple>
                                @for (item of categorySelections; track item) {
                                    <mat-option [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field style="width: 180px;">
                            <mat-label>{{ 'general.filter' | transloco }}</mat-label>
                            <input matInput inputrestriction="basic1" autocomplete="off" #filterComponents>
                            <a matSuffix aria-label="Clear" (click)="filterComponents.value = ''">
                                <mat-icon>close</mat-icon>
                            </a>
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayout="row wrap" fxLayoutAlign="space-around start" class="block-verbose-wrapper">
                        @for (block of arrayBlocks | FilterForPipe:'name':filterComponents.value; track block; let idx = $index) {
                            <div class="block-verbose">
                                <div class="headerItemBlock">
                                    <div class="d-flex-center">
                                        <fa-icon size="2xl" [icon]="block.icon"></fa-icon>
                                        <span class="label">{{ block.name }}</span>
                                    </div>
                                    <a mat-raised-button (click)="addBlockVerbose(block)">
                                        <mat-icon>add_circle_outline</mat-icon>
                                        add
                                    </a>
                                </div>
                                <div class="d-flex-center" style="margin: 0 20px;">
                                    @if (block.enterprise) {
                                        <div fxFlex="row" class="availability">
                                            <mat-icon>rocket_launch</mat-icon>
                                            <div class="availText">{{ 'general.upgradeRequired' | transloco }}</div>
                                        </div>
                                    } @else {
                                        <div fxFlex="row" class="availability">
                                            <mat-icon>task_alt</mat-icon>
                                            <div class="availText">{{ 'general.freeEveryone' | transloco }}</div>
                                        </div>
                                    }
                                    @if (block.videoHelp) {
                                        <div class="d-flex-center">
                                            <app-video-link [miniButton]="true" [videoLink]="'/help/'+block.name"></app-video-link>
                                            <div class="hide-xs">{{ 'general.videoTutorial' | transloco }}</div>
                                        </div>
                                    }
                                </div>
                                <div class="block-description" style="margin: 20px">
                                    <div class="desc">{{ block.description || "no description yet..." }}</div>
                                    @if (block.description) {
                                        <div class="hide-gt-xs show-more">show more...</div>
                                    }
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                        }
                    </div>
                </div>
            }
            @case ('BLOCK_SCHEDULER') {
                <div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px;">
                        <mat-form-field class="filter">
                            <mat-label>{{ 'general.filter' | transloco }}</mat-label>
                            <input matInput inputrestriction="basic1" autocomplete="off" #filterComponents>
                            <a matSuffix aria-label="Clear" (click)="filterComponents.value = ''">
                                <mat-icon>close</mat-icon>
                            </a>
                        </mat-form-field>
                        <div>
                            <button matTooltip="{{'general.newScheduler' | transloco}}" mat-flat-button (click)="createNewScheduler()">
                                <mat-icon style="font-size: 24px; width: 30px; height: 30px">post_add</mat-icon>
                            </button>
                        </div>
                        <div class="hide-gt-sm">
                            <app-scroll-buttons contentId="items"></app-scroll-buttons>
                        </div>
                        <app-video-link videoLink="schedulersToolbox"></app-video-link>
                    </div>
                    <div class="items-wrapper">
                        <!--        <h3 style="margin-left: 10px;">{{'general.blocks' | transloco}}</h3>-->
                        <div id="items" cdkDropList fxLayout="column" class="dragCursor addBlockWrapper" (cdkDropListDropped)="dropBlock($event)"
                             [cdkDropListData]="arrayBlocks" cdkDropListSortingDisabled>
                            @for (block of arrayBlocks | FilterForPipe:'name':filterComponents.value; track block; let idx = $index) {
                                <div class="dragCursor"
                                     cdkDrag [cdkDragData]="block"
                                     [ngStyle]="Lib.IsBlockAddable(block, user) ? {'opacity': 1} : {'opacity': 0.2}">
                                    <div fxFlex fxLayoutAlign="space-between center" class="item">
                                        <div class="d-flex-center">
                                            <a class="mini-button" mat-icon-button (click)="addBlock(block)">
                                                <mat-icon>add_circle_outline</mat-icon>
                                            </a>
                                            <span>{{ block.name }}</span>
                                            <!--                        <span *ngIf="m_addBlockType==='BLOCK_SCHEDULER'" style="padding-left: 5px; padding-right: 5px; opacity: 0.4">(id:{{block.metadata}})</span>-->
                                        </div>
                                        <div class="d-flex-center">
                                            <!--
                                            2-18-2023 removed colorized first item
                                            <app-video-link *ngIf="block.videoHelp" [ngStyle]="{color: idx === 0 && filterComponents.value === '' ? 'var(--background-blue)' : 'var(--background-color15)'}" [iconButton]="true" [videoLink]="'/help/'+block.name"></app-video-link>
                                            <fa-icon size="lg" [ngStyle]="{color: idx === 0 && filterComponents.value === '' ? 'var(--background-blue)' : 'var(--background-color15)'}" [icon]="block.icon"></fa-icon>
                                            -->
                                            <!--                        <app-video-link *ngIf="block.videoHelp" [iconButton]="true" [videoLink]="'/help/'+block.name"></app-video-link>-->
                                            <a class="mini-button" mat-icon-button (click)="jumpToSchedulers(block)">
                                                <mat-icon>link</mat-icon>
                                            </a>
                                        </div>
                                    </div>
                                    <div *cdkDragPreview class="drag-preview" [ngStyle]="{'width.px': 100, 'height.px': 100}">
                                        {{ block.name }}
                                    </div>
                                </div>
                            }
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                </div>
            }
        }
    </div>
</div>
